<template>
  <Form :model="formData" :label-width="100"  :rules="formRules" :ref="`formData${i}`">
    <FormItem label="收款方式" prop="payType" class="inline-b">
      <Select v-model="formData.payType" class="item-width" :disabled="true">
        <Option v-for="item in receiptMethodList" :value="item.value" :key="item.value">{{item.text}}</Option>
      </Select>
    </FormItem>
    <FormItem v-if="formData.payType&&payTypeCode!==3" :label-width="108" label="付款人" prop="payer" class="inline-b">
      <Input style="width:162px" v-model="formData.payer"></Input>
    </FormItem>
      <FormItem v-if="payTypeCode===2" label="支票号" prop="checkNumber" class="inline-b">
      <Input class="item-width" v-model="formData.checkNumber"></Input>
    </FormItem>
    <FormItem v-if="payTypeCode===1" label="终端号" prop="posId" key="posId" class="inline-b">
      <!-- <Input class="item-width" v-model="formData.posId" :disabled="true"></Input> -->
      <Select v-model="formData.posId" class="item-width">
        <Option v-for="item in referenceNumList" :value="item.terminalNo" :key="item.terminalNo">{{item.terminalNo}}</Option>
      </Select>
    </FormItem>
    <FormItem v-if="formData.payType && (payTypeCode===0 || payTypeCode===3)" key="paySerialNum" :label="paySerialLabel" prop="paySerialNum" class="inline-b">
      <Input class="item-width" v-model="formData.paySerialNum"></Input>
    </FormItem>

    <FormItem v-if="payTypeCode ===1" label="参考号" prop="referenceNum" class="inline-b">
      <Input class="item-width" v-model="formData.referenceNum" :placeholder="referenceNumLen ? `参考号后${referenceNumLen}位` :'' "></Input>
    </FormItem>
    <FormItem v-if="formData.payType && (payTypeCode!==3 && payTypeCode!==2)" label="收款账户" prop="remittanceAccount" class="inline-b">
      <Input  class="item-width" :disabled="true" v-model="formData.remittanceAccount" ></Input>
    </FormItem>
    <div>
      <FormItem label="收款金额" prop="factPayment" class="inline-b">
        <Input class="item-width" v-model="formData.factPayment" :placeholder="payTypeCode===1 ? '上传小票后自动读取' :'' "></Input>
      </FormItem>
      <FormItem label="实际支付日期" :label-width="108" prop="payTime" class="inline-b">
        <DatePicker style="width:162px" type="datetime" v-model="formData.payTime"  @on-change="getPayTime" ></DatePicker>
      </FormItem>
    </div>
    <FormItem label="备注" prop="remark">
      <Input v-model="formData.remark" type="textarea" :rows="1"  style="width:424px"></Input>
    </FormItem>
    <div class="ivu-form-item-required ivu-form-item ">
        <span style="width:100px;" class="inline-b ivu-form-item-label">附件</span>
        <div class="upload-wrap">
          <img class="imgwidth" v-if="formData.attach"  :src="formData.attach" @click="showImg(formData.attach)"/>
          <Upload
            :action="baseUrl+'/file/uploadFile'"
            :on-success="setAttach"
            :headers="{'Access-Token':token}"
            :show-upload-list="false"
            :format="['jpg','jpeg','png']"
            :on-format-error="handleFormatError"
          >
            <div v-if="!formData.attach" class="upload" :class="{error: !validateAttach}">
              <Icon type="ios-upload-outline" color="#DDDEE1" size="40" style="vertical-align: middle"></Icon>
              <p>点击上传图片</p>
            </div>
            <a v-if="!formData.attach && !validateAttach" class="error-color" href="javascript:;">请上传附件</a>
            <a v-if="formData.attach" href="javascript:;">修改</a>
          </Upload>
        </div>
      </div>
  </Form>
</template>

<script type="text/ecmascript-6">

import { getPosTerminal } from 'api/accountsReceivable';
import { getBaseUrl } from "@/utils/public";
import { getToken } from "@/utils/auth";
import {ocrinfo} from "api/ocr";

export default {
  name:'Collectionitem',
  props:{
    i:{
      type:Number,
      default:0
    },
    projectFid:{
      type:String,
      default:''
    },
    receiptMethodList:{
      type:Array,
      default: ()=>{
        return []
      }
    },
    parentContractCode:{
      type:String,
      default:''
    },
    billNum:{
      type:String,
      default:''
    },
    formData:{
      type:Object,
      default:null
    }
  },
  created(){
    this.baseUrl = getBaseUrl()
    this.token = getToken()
  },
  computed:{
    payTypeCode(){
      let payType = this.formData.payType
      let type = 0 // type:0银行，1pos机，2支票,3虚拟抵扣,
      let patternYh = /^yhzz/
      let patternZp = /^zp/
      let patternPos = /^pos/
      let patternXndk = /^mzjxndk/
      if(patternYh.test(payType)){
        type = 0
      } else if(patternPos.test(payType)){
        type = 1
      } else if(patternZp.test(payType)){
        type = 2
      }else if(patternXndk.test(payType)){
        type = 3
      }
     // this.getPosTerminalInfo()
      return type
    },
    paySerialLabel(){
      let label = ''
      switch(this.payTypeCode){
        case 0 :
          label = '付款账号'
          break;
        case 3 :
          label = 'OA审批申请号'
          break;
        default:
          label = '付款账号'
      }
      return label
    },
    referenceNumLen(){
      let terminalNo = this.formData.posId
      let len = 0
      this.referenceNumList.forEach(item => {
        if (item.terminalNo === terminalNo){
          len = item.referenceNum ? item.referenceNum : 0
        }
      })
      return len
    }
  },
  watch:{
    parentContractCode(val){
      this.clearDate()
    },
    billNum(val){
      this.clearDate()
    }
  },
  data () {
    const validateDate = (rules,value,callback)=>{
      rules.type = typeof value === 'object' ? 'object':'string'
      if(!value){
        callback(new Error('请选择支付时间'));
      }
      callback();
    }
    const validatePrice = (rule, value, callback)=>{
      const pattern = /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/
      if(pattern.test(value)){
        this.$emit('inputPayment')
        callback();
      }else {
        callback(new Error('输入正确的数字'));
      }
    }
    const validateReferenceNum = (rule, value ,callback) => {
      let count = this.referenceNumLen
      let patternStr = `^[A-Za-z0-9]{${count}}$`
      const pattern = new RegExp(patternStr)
      if(!count || pattern.test(value)){
        callback();
      }else {
        callback(new Error('输入正确位数的参考号'));
      }
    }
    const paySerialNum = (rule, value ,callback) => {
      let str = this.paySerialLabel
      if(value){
        callback()
      }else{
        callback(new Error(str))
      }
    }
    return {
      payTime:"",
      validateAttach:true,
      referenceNumList:[],
      // referenceNumLen:0,
      referenceNumStr:'',
      dateOption:{
        disabledDate (date) {
          return date && date.valueOf() > Date.now();
        }
      },
      formRules:{
        checkNumber:[ { required:true, message:'请输入支票号', trigger:'blur' } ],
        payType:[ { required:true, message:'请选择付款方式', trigger:'change' } ],
        payer:[ { required:true, message:'请输入付款人', trigger:'blur' } ],
        posId:[ { required:true, message:'请输入终端号', trigger:'change' } ],
        payTime:[ { required:true, validator: validateDate, trigger:'change' } ],
        referenceNum:[ { required:true, validator:validateReferenceNum, trigger:'blur' } ],
        remittanceAccount:[ { required:true, message:'请输入汇入账号', trigger:'blur' } ],
        factPayment:[ { required:true, validator:validatePrice, trigger:'blur' } ],
        paySerialNum:[ { required:true, message:'请输入付款账号', trigger:'blur' } ],
      }
    };
  },
  methods:{
    ocrinfo(url){
      let params={
        imageUrl:url
      }
      ocrinfo(params).then(res=>{
        if(!res.data){
          return
        }
        res.data.referNumber&&( this.formData.referenceNum=this.referenceNumLen?res.data.referNumber.slice(-this.referenceNumLen):res.data.referNumber)
        // res.data.amount &&(this.formData.factPayment=res.data.amount)

        if(res.data.amount){
          this.formData.factPayment=res.data.amount
          this.$emit('inputPayment')

        }


      }).catch(error=>{})

    },
    clearDate(){
      this.$refs[`formData${this.i}`].resetFields();
      for(let key in this.formData) {
        this.formData[key] = ''
      }
    },
    getPosTerminalInfo(){
      let projectFid = this.projectFid
      let bankName = ''
      for (let [index, item] of this.receiptMethodList.entries()) {
        if (this.formData.payType === item.value) {
          bankName = this.receiptMethodList[index].bankName;
          this.formData.remittanceAccount = this.receiptMethodList[index].bankAccount;
        }
      }
      this.getPosTerminal(projectFid,bankName)
    },
    changePayType(val){
      let projectFid = this.projectFid
      let bankName = ''

      if(this.payTypeCode === 2 || this.payTypeCode===3) return
      for (let [index, item] of this.receiptMethodList.entries()) {
        if (val === item.value) {
          bankName = this.receiptMethodList[index].bankName;
          this.formData.remittanceAccount = this.receiptMethodList[index].bankAccount;
        }
      }
      if(this.payTypeCode ===1){
        this.getPosTerminal(projectFid,bankName)

        if(this.formData.attach){
          this.ocrinfo(this.formData.attach)
        }
      }
    },
    deleteItem(){
      this.$emit('delete-item',this.i)
    },
    formValidate() {
      let obj = {}
      this.$refs[`formData${this.i}`].validate( bool => {
        if(bool){
          if(this.formData.attach){
            obj = Object.assign({},this.formData)
            obj.factPayment  = (obj.factPayment*100).toFixed(0)
          }else{
            this.validateAttach = false
            obj = false
          }
        }else{
            obj = false
        }
      })
      return obj
    },
    getPayTime(val){
       this.formData.payTime = val
    },
    handleFormatError() {
      this.$Message.error('请输入jpg,jpeg,png,格式的文件')
    },
    setAttach(response){
      if(response.data){
        this.formData.attach = response.data.url
        this.validateAttach = true

        if(this.payTypeCode===1){
          this.ocrinfo(this.formData.attach)
        }
      }
    },
    showImg(img) {
      this.$emit('show-img',img)
    },
    getPosTerminal(projectFid,bankName){
      getPosTerminal(projectFid,bankName).then(res => {
        this.referenceNumList = res.data ? res.data : []
        // this.referenceNumLen = res.data[0].referenceNum ?  res.data[0].referenceNum : 0 //参考号位数
        // this.referenceNumStr = res.data[0].referenceNum ?  `参考号后${res.data[0].referenceNum}位` : ''
        // this.formData.posId =  res.data[0].terminalNo // 终端号位数
      })
    }
  }
}
</script>

<style lang="css" scoped>
 .item-width {
  width:150px;
}
.upload-wrap {
  display: inline-block;
  line-height: 1;
  padding: 10px 4px;
}
 .imgwidth {
  width: 167px;
  height: 118px;
}
.upload {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #DDDEE1;
  width: 167px;
  height: 118px;
  border: 1px dashed rgb(220, 220, 220);
  box-sizing: border-box;
  text-align: center;
}
.ivu-upload {
  position: relative;
}
.ivu-upload  a {
  position :absolute;
  right: 0;
  bottom: -6px;
}
.upload.error {
  border-color:#F56356;
}
a.error-color {
  color:#F56356;
  bottom: -18px;

}
.btn-wrap {
width: 100%;
text-align: center;
}
</style>
